import React, { memo, useContext } from 'react';
import ChevronRight from 'mdi-react/ChevronRightIcon';
import { AppContext } from '@prisjakt/ui-app-context';

import * as S from './styles';

type OwnProps = {
  disabled?: boolean;
  featured?: boolean;
  visible?: boolean;
};

type Props = OwnProps;

const GoToStoreButton = ({
  visible = false,
  disabled = false,
  featured = true,
}: Props) => {
  const { t } = useContext(AppContext);
  const title = t('product', 'store.link');

  return (
    <S.StoreLink
      visible={visible}
      disabled={disabled}
      data-test="GoToStoreButton"
      tabIndex={0}
    >
      <S.LinkDesktop
        ariaLabel={title}
        variant={featured ? 'default' : 'text'}
        color={featured ? 'positive' : 'link'}
        icon={<ChevronRight />}
        iconPosition="right"
      >
        {title}
      </S.LinkDesktop>
      <S.LinkMobile ariaLabel={title} color="link" size="large">
        <ChevronRight />
      </S.LinkMobile>
    </S.StoreLink>
  );
};

export default memo(GoToStoreButton);
